<script>
  export let message = "We couldn't submit your review"
</script>

<style>
  :global(._1vyza) {
    position: absolute;
    width: 460px;
    height: 571px;
    z-index: 99;
    top: -700px;
    background: #fff;
    padding: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    transition: 0.2s;
  }

  :global(._FVRa) {
    top: 0;
    left: 0;
  }

  :global(.jUDAv) {
    display: inline-block;
    margin: auto;
  }

  :global(._2C7Mw) {
    font-size: 18px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
</style>

<div id="error-section" class="_1vyza _FVRa">
  <div class="jUDAv">
    <div class="">
      <img
        src="https://statisc2test.kudobuzz.com/icons/icon-error.svg"
        alt="checkmark" />
    </div>
    <div class="_2C7Mw">{message}</div>
  </div>
</div>
